<div class="forgot-email__container basic-login ">
    <h2 class="uiHeaderTitle">Forgot Password</h2>
    <form #forgotEmail="ngForm" (ngSubmit)="emailForgot(forgotEmail)">
      <div class="form-group">
        <label for="email" class="form-label">Email</label>
        <input 
          type="email" 
          class="form-control" 
          placeholder="Email"
          name="email"
          [(ngModel)]="userEmail"
          required
          pattern="[a-z0-9._%+\\-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          #uemail="ngModel"
          [ngClass]="{ 'is-invalid': forgotEmail.submitted && uemail.invalid }"
        />
        <div *ngIf="forgotEmail.submitted && uemail.errors" class="invalid-feedback">
          <div *ngIf="uemail.errors?.['required']">Email is required</div>
          <div *ngIf="uemail.errors?.['email']">Email is invalid</div>
          <div *ngIf="uemail.errors?.['pattern']">Invalid email format</div>
        </div>
      </div>
      <button class="primary-join-btn w-100" type="submit">Send Email</button>
    </form>
    

</div>